import { z } from 'zod';
/** One uploaded file and how its import went (ADR-020). */
export const importKindSchema = z.enum(['recipes']);
export const importStatusSchema = z.enum(['queued', 'running', 'done', 'failed']);
export const importOutcomeSchema = z.object({
    title: z.string(),
    outcome: z.enum(['created', 'skipped', 'failed']),
    /** Why it was skipped or failed, in a sentence. */
    reason: z.string().nullable(),
    recipeId: z.string().uuid().nullable(),
});
export const importSummarySchema = z.object({
    items: z.array(importOutcomeSchema).default([]),
    /** What the parser could not read or did not recognise; never fatal. */
    warnings: z.array(z.string()).default([]),
});
export const importRunSchema = z.object({
    id: z.string().uuid(),
    kind: importKindSchema,
    format: z.string().nullable(),
    filename: z.string(),
    status: importStatusSchema,
    jobId: z.string().uuid().nullable(),
    createdCount: z.number().int(),
    skippedCount: z.number().int(),
    failedCount: z.number().int(),
    summary: importSummarySchema,
    error: z.string().nullable(),
    createdAt: z.date(),
    finishedAt: z.date().nullable(),
});
/** A format the importer can read, for the picker. */
export const importFormatSummarySchema = z.object({
    key: z.string(),
    label: z.string(),
    kind: importKindSchema,
    /** File extensions, with the dot. */
    accepts: z.array(z.string()),
});
export const IMPORT_FORMATS = [
    {
        key: 'recipe-keeper',
        label: 'Recipe Keeper export (.zip)',
        kind: 'recipes',
        accepts: ['.zip'],
    },
];
//# sourceMappingURL=import.js.map